import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardHeader from '../components/DashboardHeader';
import TermsModal from '../components/TermsModal';
import './ReturnExchangePolicy.css';

function ReturnExchangePolicy() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showGreenBar, setShowGreenBar] = useState(true);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Hide green bar on scroll (no animation, instant show/hide)
  useEffect(() => {
    const handleScroll = () => {
      setShowGreenBar(window.scrollY === 0);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const policyItems = [
    {
      number: "1",
      title: "Can I return or exchange plants?",
      content: [
        "We understand that plants are delicate and may be affected during transit. If your plant arrives damaged or dead and was delivered via our in-house team, we will replace it once free of charge.",
        "If your plant arrived healthy but you changed your mind, we unfortunately cannot accept returns or exchanges, as plants are perishable."
      ]
    },
    {
      number: "2",
      title: "What is the return/exchange process?",
      content: [
        "Please email us at chiquisgarderlandscapingservic@gmail.com within 24 hours of receiving your order.",
        "Include:",
        "• Your order number",
        "• Photos clearly showing the issue",
        "• We'll review and get back to you as soon as possible."
      ]
    },
    {
      number: "3",
      title: "What if I used a third-party courier?",
      content: [
        "If you opted for your own courier, Chiqui's Garden is not responsible for any damage, delay, or loss during delivery.",
        "Returns/exchanges may still be possible, but you'll need to cover all transport fees."
      ]
    },
    {
      number: "4",
      title: "Can I return sale items?",
      content: [
        "All sale items are final sale and non-refundable."
      ]
    },
    {
      number: "5",
      title: "Refunds for PayMongo payments",
      content: [
        "If you paid using PayMongo (credit/debit card or GCash via PayMongo), refunds are not available.",
      ]
    },
    {
      number: "6",
      title: "Do you accept exchanges for non-plant items?",
      content: [
        "Yes, case-by-case. Notify us within 24 hours, provide photos, and email us at chiquisgarderlandscapingservic@gmail.com"
      ]
    }
  ];

  return (
    <div style={{ background: 'linear-gradient(180deg, #f8fdf9 0%, #f0f7f1 100%)', minHeight: '100vh', width: '100vw', display: 'flex', flexDirection: 'column' }}>
      {/* Green Header Bar (thinner) - only visible at top */}
      {showGreenBar && (
        <div style={{ width: '100%', background: 'linear-gradient(90deg, #175c36 0%, #1a6b3f 100%)', minHeight: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 8px rgba(23, 92, 54, 0.2)' }}>
          {/* Empty green bar for accent */}
        </div>
      )}
      {/* Navbar always sticky at top */}
      <div style={{ 
        width: '100%', 
        background: 'rgba(255, 255, 255, 0.98)', 
        backdropFilter: 'blur(10px)', 
        boxShadow: '0 4px 16px rgba(0,0,0,0.10)', 
        position: 'sticky',
        top: 0, 
        zIndex: 9998,
        borderBottom: '1px solid rgba(0, 0, 0, 0.06)'
      }}>
        <div style={{ width: '100%', maxWidth: '1800px', margin: '0 auto', background: 'transparent' }}>
          <DashboardHeader />
        </div>
      </div>
      <div style={{ width: '100%', flex: 1 }} className="page-content-fade-in">

      {/* Main Content */}
      <div style={{ 
        width: '100%', 
        maxWidth: '900px', 
        margin: '0 auto', 
        padding: isMobile ? '20px 16px 40px' : '40px 24px 60px'
      }}>
        <div>
          {/* Header */}
          <div
            style={{ 
              textAlign: 'center', 
              marginBottom: isMobile ? '32px' : '48px' 
            }}
          >
            <h1 style={{ 
              fontSize: isMobile ? '2rem' : '2.5rem', 
              fontWeight: 700,
              color: '#1e293b',
              marginBottom: '12px',
              lineHeight: 1.2
            }}>
              Return and Exchange Policy
            </h1>
            <p style={{ 
              fontSize: isMobile ? '1rem' : '1.1rem', 
              color: '#64748b',
              lineHeight: 1.6,
              maxWidth: '700px',
              margin: '0 auto'
            }}>
              We want you to be completely satisfied with your purchase. Please read our policy carefully.
            </p>
          </div>

          {/* Policy Items */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: isMobile ? '20px' : '24px' }}>
            {policyItems.map((item, index) => (
              <div
                key={index}
                className="policy-card"
                style={{
                  background: '#fff',
                  borderRadius: '16px',
                  padding: isMobile ? '24px 20px' : '32px 36px',
                  boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
                  border: '1px solid rgba(0, 0, 0, 0.06)',
                  overflow: 'hidden'
                }}
              >
                <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                  {/* Number Badge */}
                  <div style={{
                    width: isMobile ? '36px' : '44px',
                    height: isMobile ? '36px' : '44px',
                    minWidth: isMobile ? '36px' : '44px',
                    borderRadius: '12px',
                    background: 'linear-gradient(135deg, #15803d 0%, #16a34a 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    fontSize: isMobile ? '1.25rem' : '1.5rem',
                    fontWeight: 700,
                    boxShadow: '0 4px 12px rgba(21, 128, 61, 0.3)'
                  }}>
                    {item.number}
                  </div>

                  {/* Content */}
                  <div style={{ flex: 1 }}>
                    <h2 style={{ 
                      fontSize: isMobile ? '1.15rem' : '1.35rem', 
                      fontWeight: 700,
                      color: '#15803d',
                      marginBottom: '16px',
                      lineHeight: 1.3
                    }}>
                      {item.title}
                    </h2>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                      {item.content.map((paragraph, pIndex) => (
                        <p
                          key={pIndex}
                          className="policy-text"
                          style={{ 
                            fontSize: isMobile ? '0.95rem' : '1.05rem', 
                            color: '#475569',
                            lineHeight: 1.7,
                            margin: 0,
                            paddingLeft: paragraph.startsWith('•') || paragraph.startsWith('>') ? '8px' : '0',
                            fontWeight: paragraph.startsWith('Include:') ? 600 : 400
                          }}
                        >
                          {paragraph}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Contact CTA */}
          <div
            style={{
              marginTop: isMobile ? '32px' : '48px',
              background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)',
              borderRadius: '16px',
              padding: isMobile ? '28px 24px' : '36px 40px',
              textAlign: 'center',
              border: '2px solid #bbf7d0',
              boxShadow: '0 4px 16px rgba(21, 128, 61, 0.1)'
            }}
          >
            <h3 style={{ 
              fontSize: isMobile ? '1.25rem' : '1.5rem', 
              fontWeight: 700,
              color: '#15803d',
              marginBottom: '12px'
            }}>
              Have Questions?
            </h3>
            <p style={{ 
              fontSize: isMobile ? '0.95rem' : '1.05rem', 
              color: '#166534',
              marginBottom: '20px',
              lineHeight: 1.6
            }}>
              Contact us within 24 hours of receiving your order for any concerns.
            </p>
            <a 
              href="mailto:chiquisgarderlandscapingservic@gmail.com"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                padding: isMobile ? '12px 24px' : '14px 32px',
                background: '#15803d',
                color: '#fff',
                borderRadius: '10px',
                fontSize: isMobile ? '1rem' : '1.05rem',
                fontWeight: 600,
                textDecoration: 'none',
                boxShadow: '0 4px 12px rgba(21, 128, 61, 0.3)'
              }}
            >
              <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
              </svg>
              Email Us
            </a>
          </div>

          {/* Back to Home */}
          <div
            style={{ 
              marginTop: '32px', 
              textAlign: 'center' 
            }}
          >
            <button
              onClick={() => navigate('/')}
              style={{
                padding: isMobile ? '12px 28px' : '14px 36px',
                background: 'transparent',
                border: '2px solid #15803d',
                color: '#15803d',
                borderRadius: '10px',
                fontSize: isMobile ? '1rem' : '1.05rem',
                fontWeight: 600,
                cursor: 'pointer'
              }}
            >
              ← Back to Home
            </button>
          </div>
        </div>
      </div>

      {/* Footer (copied from Home page for consistency) */}
      <footer style={{
        width: '100%',
        background: 'linear-gradient(135deg, #0f4527 0%, #145a34 50%, #0f4527 100%)',
        marginTop: 'auto',
        boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.25)',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'radial-gradient(circle at 30% 50%, rgba(255,255,255,0.03) 0%, transparent 70%)',
          pointerEvents: 'none'
        }} />

        <div style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '40px 20px 20px',
          position: 'relative',
          zIndex: 1
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '40px',
            alignItems: 'start',
            marginBottom: '35px'
          }}>
            {!isMobile && <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <h3 style={{
                color: 'rgba(255, 255, 255, 0.95)',
                fontSize: '0.75rem',
                fontWeight: 700,
                letterSpacing: '2px',
                textTransform: 'uppercase',
                margin: 0,
                marginBottom: '4px'
              }}>Connect With Us</h3>
              <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                <a
                  href="https://www.facebook.com/profile.php?id=61552636677232"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                  style={{
                    width: '44px',
                    height: '44px',
                    borderRadius: '12px',
                    background: 'rgba(255, 255, 255, 0.1)',
                    backdropFilter: 'blur(10px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    border: '1.5px solid rgba(255, 255, 255, 0.15)',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                    textDecoration: 'none'
                  }}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="#ffffff">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
                <a
                  href="https://www.messenger.com/t/61552636677232"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Messenger"
                  style={{
                    width: '44px',
                    height: '44px',
                    borderRadius: '12px',
                    background: 'rgba(255, 255, 255, 0.1)',
                    backdropFilter: 'blur(10px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    border: '1.5px solid rgba(255, 255, 255, 0.15)',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                    textDecoration: 'none'
                  }}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="#ffffff">
                    <path d="M12 2C6.477 2 2 6.145 2 11.243c0 2.875 1.44 5.449 3.687 7.126V22l3.486-1.914c.93.257 1.913.395 2.827.395 5.523 0 10-4.145 10-9.243S17.523 2 12 2zm.993 12.437l-2.552-2.725-4.983 2.725 5.48-5.813 2.613 2.725 4.922-2.725-5.48 5.813z"/>
                  </svg>
                </a>
                <a
                  href="viber://chat?number=639368983053"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Chat"
                  style={{
                    width: '44px',
                    height: '44px',
                    borderRadius: '12px',
                    background: 'rgba(255, 255, 255, 0.1)',
                    backdropFilter: 'blur(10px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    border: '1.5px solid rgba(255, 255, 255, 0.15)',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                    textDecoration: 'none'
                  }}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="#ffffff">
                    <path d="M11.4 0C9.473.028 5.333.344 3.02 2.467 1.302 4.187.696 6.7.633 9.817.57 12.933.488 18.776 6.12 20.36h.003l-.004 2.644s-.037.977.61 1.177c.777.242 1.234-.5 1.977-1.303.41-.44.972-1.084 1.397-1.58 3.85.326 6.812-.417 7.15-.526.776-.253 5.176-.816 5.892-6.657.74-6.02-.36-9.83-2.34-11.546-.596-.55-3.006-2.3-8.375-2.323 0 0-.395-.025-1.026-.017z"/>
                  </svg>
                </a>
              </div>
            </div>}

            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '12px',
              justifySelf: 'center',
              marginBottom: isMobile ? '10px' : '0'
            }}>
              <div style={{
                width: '60px',
                height: '60px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.05) 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '2.5px solid rgba(255, 255, 255, 0.25)',
                padding: '10px',
                boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3), inset 0 2px 4px rgba(255, 255, 255, 0.1)',
                position: 'relative'
              }}>
                <img
                  src="/images/chiqui_logo_white-outline.svg"
                  alt="Chiqui's Garden Logo"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))'
                  }}
                />
              </div>
              <div style={{ textAlign: 'center' }}>
                <div style={{
                  color: '#ffffff',
                  fontSize: '1rem',
                  fontWeight: 700,
                  letterSpacing: '0.5px',
                  marginBottom: '4px',
                  textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                }}>Chiqui's Garden</div>
                <div style={{
                  color: 'rgba(255, 255, 255, 0.7)',
                  fontSize: '0.75rem',
                  fontWeight: 400
                }}>© {new Date().getFullYear()} All Rights Reserved</div>
              </div>
            </div>

            {!isMobile && <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              justifySelf: 'end'
            }}>
              <h3 style={{
                color: 'rgba(255, 255, 255, 0.95)',
                fontSize: '0.75rem',
                fontWeight: 700,
                letterSpacing: '2px',
                textTransform: 'uppercase',
                margin: 0,
                marginBottom: '4px'
              }}>Our Location</h3>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                background: 'rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(10px)',
                padding: '14px 18px',
                borderRadius: '16px',
                border: '1.5px solid rgba(255, 255, 255, 0.15)',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)'
              }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '10px',
                  background: 'rgba(255, 255, 255, 0.15)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="rgba(255, 255, 255, 0.95)">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                  </svg>
                </div>
                <div>
                  <div style={{
                    color: '#ffffff',
                    fontSize: '0.9rem',
                    fontWeight: 600,
                    marginBottom: '3px',
                    letterSpacing: '0.3px'
                  }}>Iba Garden</div>
                  <div style={{
                    color: 'rgba(255, 255, 255, 0.8)',
                    fontSize: '0.8rem',
                    lineHeight: '1.3'
                  }}>Pulong Iba, Silang, Cavite</div>
                </div>
              </div>
            </div>}
          </div>

          <div style={{
            width: '100%',
            height: '1px',
            background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
            margin: isMobile ? '20px 0' : '25px 0'
          }} />

          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            gap: isMobile ? '8px' : '30px',
            paddingBottom: '10px'
          }}>
            <a href="/about" style={{ color: 'rgba(255, 255, 255, 0.85)', fontSize: isMobile ? '0.7rem' : '0.85rem', fontWeight: 500, textDecoration: 'none', letterSpacing: '0.5px', padding: isMobile ? '4px 8px' : '6px 12px', borderRadius: '6px', whiteSpace: 'nowrap' }}>About Us</a>
            <a href="/contact" style={{ color: 'rgba(255, 255, 255, 0.85)', fontSize: isMobile ? '0.7rem' : '0.85rem', fontWeight: 500, textDecoration: 'none', letterSpacing: '0.5px', padding: isMobile ? '4px 8px' : '6px 12px', borderRadius: '6px', whiteSpace: 'nowrap' }}>Contact Info</a>
            <a href="/return-policy" style={{ color: 'rgba(255, 255, 255, 0.85)', fontSize: isMobile ? '0.7rem' : '0.85rem', fontWeight: 500, textDecoration: 'none', letterSpacing: '0.5px', padding: isMobile ? '4px 8px' : '6px 12px', borderRadius: '6px', whiteSpace: 'nowrap' }}>Return & Exchange Policy</a>
            <button onClick={() => setShowTermsModal(true)} style={{ color: 'rgba(255, 255, 255, 0.85)', fontSize: isMobile ? '0.7rem' : '0.85rem', fontWeight: 500, textDecoration: 'none', letterSpacing: '0.5px', padding: isMobile ? '4px 8px' : '6px 12px', borderRadius: '6px', whiteSpace: 'nowrap', cursor: 'pointer', background: 'transparent', border: 'none' }}>Terms of Use</button>
            <button onClick={() => setShowPrivacyModal(true)} style={{ color: 'rgba(255, 255, 255, 0.85)', fontSize: isMobile ? '0.7rem' : '0.85rem', fontWeight: 500, textDecoration: 'none', letterSpacing: '0.5px', padding: isMobile ? '4px 8px' : '6px 12px', borderRadius: '6px', whiteSpace: 'nowrap', cursor: 'pointer', background: 'transparent', border: 'none' }}>Privacy Policy</button>
          </div>
        </div>
      </footer>

      {/* Terms & Privacy Modals */}
      <TermsModal
        isOpen={showTermsModal}
        onClose={() => setShowTermsModal(false)}
      />
      <TermsModal
        isOpen={showPrivacyModal}
        onClose={() => setShowPrivacyModal(false)}
        isPrivacyPolicy={true}
      />
      </div>
    </div>
  );
}

export default ReturnExchangePolicy;
